import { unityPropsContext } from 'components/UnityPropsContext'
import React, { FC, ReactElement, useContext, useState } from 'react'
import styled from 'styled-components'
import type { Question } from 'Types/Questions'

interface Props {
  question: Question
  municipalityName?: string
  isMunicipalityTitle?: boolean
  hideLocation?: boolean
}
const QuestionTitle: FC<Props> = ({
  question,
  municipalityName,
  isMunicipalityTitle = false,
  hideLocation = false,
}): ReactElement => {
  const unityProps = useContext(unityPropsContext)
  const isFrench = unityProps.lang == 'fr'
  function getLocationNameWithArticle() {
    if (isMunicipalityTitle) {
      if (municipalityName) {
        let place = municipalityName?.trim()
        if (isFrench) {
          if (place?.startsWith('Le ') || place?.startsWith('le ')) {
            return 'au ' + place?.replace('Le ', '').replace('le ', '')
          } else {
            if (place?.startsWith('Les ') || place?.startsWith('les ')) {
              return 'aux ' + place?.replace('Les ', '').replace('les ', '')
            } else {
              return 'à ' + place
            }
          }
        } else {
          return 'in ' + place
        }
      } else {
        return unityProps.inYourMunicipality
      }
    } else {
      return unityProps.inSwitzerland
    }
  }
  return (
    <Title htmlFor={question.id + (isMunicipalityTitle ? '-gemeinde' : '')}>
      <h3>
      <NumberContainer><Number /><NumberSmall>/13</NumberSmall></NumberContainer>
        {isFrench ? (
          <>
            {question.meta.question}
            <span
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {' '}
              {!hideLocation && <> {getLocationNameWithArticle() + '?'}</>}
            </span>{' '}
          </>
        ) : (
          <>
            <span
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {' '}
              {!hideLocation && <> {getLocationNameWithArticle()}</>}
            </span>{' '}
            {question.meta.question}
          </>
        )}
      </h3>
      {question.meta.description && <Description>
        <InfoButton>
          <svg
            viewBox='0 0 24 24'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
          >
            <title>Mehr Infos</title>
            <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
              <g
                id='ic_info_1empx'
                transform='translate(2.000000, 2.000000)'
                fill='var(--text-color)'
              >
                <path
                  d='M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M11,15 L9,15 L9,9 L11,9 L11,15 Z M11,7 L9,7 L9,5 L11,5 L11,7 Z'
                  id='Shape'
                ></path>
              </g>
            </g>
          </svg>
        </InfoButton>
        {question.meta.description}
      </Description>}
    </Title>
  )
}
const InfoButton = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 0.2em;
  div {
    transition: all 200ms ease-out;
    opacity: 0;
  }
  svg {
    min-width: 1.1em;
    width: 1.1em;
    transition: all 200ms ease-out;
  }
`

const Title = styled.label`
  display: flex;
  flex-direction: column;
  text-align: left;

  h3 {
    font-size: 1.9em;
    line-height: 1.4em;
    margin-bottom: .5em;
    position: relative;
    padding-left: 2.85em;

    @media screen and (max-width: 600px) {
      font-size: 1.7em;
    }
  }

  p {
    font-size: 1.4em;
  }
`
const Description = styled.div`
  margin-bottom: 1em;
  margin-top: 0.5em;
  opacity: 0.7;
  font-size: 1.2em;
  /* line-height: 1.4em; */
  display: flex;
`

const NumberContainer = styled.div`
background-color: var(--ui-background-color);
position: absolute;
color: var(--site-background);
display: inline-flex;
justify-content: center;
margin: auto;
margin-right: 0.5em;
top: 0;
left: 0;
align-items: center;
padding: 0.7em 0.3em;
line-height: 0;
`

const NumberSmall = styled.div`
  font-size: 0.5em;
  font-weight: 300;
  margin-top: 0.5em;
  margin-left: 0.25em;
`

const Number = styled.div`
  font-weight: 800;
  font-family: var(--font-sans-serif);
  line-height: 0;
  font-size: 1em;

  &:after {
    content: counter(question);
  }
`

export default QuestionTitle
